/* eslint-disable */
/* eslint-disable prettier/prettier */
import * as React from 'react';
import Icon from '@ant-design/icons';

export const TourCorrectIcon = (props) => (
  <Icon {...props} component={() => <CorrectSvg {...props} />} />
);

// export const CorrectSvg = ({fill="#ff0001"}) => {
export const CorrectSvg = ({ fill = '#942820' }) => {
  return (
    <svg viewBox="0 0 51.83384 187.39784">
      <title>TourCorrectIcon</title>
      <path
        fill={fill}
        d="M341.467,283.98465"
        transform="translate(-337.0738 -212.85216)"
      />
      <path
        fill={fill}
        stroke={fill}
        strokeMiterlimit="10"
        strokeWidth="4px"
        d="M341.467,283.66177V226.65686a10,10,0,0,1,6.79349-9.472l0.41089-.1391c7.89026-2.671,20.88678-2.941,28.88116-.59985h0.00006a9.68322,9.68322,0,0,1,6.96179,9.29291V283.6517c0,0.22125-21.10083,51.32443-21.93927,51.32761C361.73725,334.98248,341.467,283.87637,341.467,283.66177Z"
        transform="translate(-337.0738 -212.85216)"
      />
      <circle
        fill={fill}
        stroke={fill}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="4px"
        cx="25.91692"
        cy="161.48093"
        r="23.91692"
      />
    </svg>
    // <svg viewBox="0 0 47.04739 167.69978">
    //     <title>TourCorrectIcon</title>
    //     <path fill={fill} d="M681.05441,412.98465" transform="translate(-679.05442 -341.85216)"/>
    //     <path fill={fill} strokeMiterlimit="10" strokeWidth="4px" stroke={fill} d="M681.05442,412.66177V355.65686a10,10,0,0,1,6.79349-9.472l0.41089-.1391c7.89026-2.671,20.88678-2.941,28.88116-.59985H717.14a9.68322,9.68322,0,0,1,6.96179,9.29291V412.6517c0,0.22125-21.10083,51.32443-21.93927,51.32761C701.32465,463.98248,681.05442,412.87637,681.05442,412.66177Z" transform="translate(-679.05442 -341.85216)"/>
    //     <circle fill={fill} strokeLinecap="round" strokeMiterlimit="10" strokeWidth="4px" stroke={fill} cx="23.5237" cy="150.48023" r="15.21955"/>
    // </svg>
  );
};

export const FingerDrawIcon = (props) => (
  <Icon {...props} component={() => <FingerDrawSvg {...props} />} />
);

export const FingerDrawSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 43.44 47.88" width={width} height={height}>
      <g>
        <g>
          <g>
            <g id="Finger_Draw_icon_White" data-name="Finger Draw icon White">
              <path
                className="cls-1"
                style={{
                  fill: 'none',
                  stroke: '#333',
                  strokeMiterlimit: 10,
                  strokeWidth: 2,
                }}
                d="M42.12,37.71l-.07-.14-1.43-3A2.61,2.61,0,0,0,38.37,33a9.71,9.71,0,0,0-3.42.51h0a6.69,6.69,0,0,0-1,.37,11.47,11.47,0,0,0-1.9,1,.91.91,0,0,1-.35.26.84.84,0,0,1-.2,0l-3.21-6.68a.92.92,0,0,0-1.21-.43l-.35.16a.91.91,0,0,0-.43,1.21L29.91,37l.15.33a1,1,0,0,0,.17.24l.6,1.26a2.51,2.51,0,0,1-.13.28l-1.48-.82-.79-.44a1.15,1.15,0,0,0-1.56.44l0,.08a1.15,1.15,0,0,0,.44,1.56l2.27,1.27,2.38,1.33,1,.59a4.18,4.18,0,0,0,3.47,1.54s.76,1.51,1.28,2.6a20,20,0,0,0,5.07-2.58c-.44-.79-1.09-2-1.32-2.42A4.21,4.21,0,0,0,42.12,37.71Z"
              />
              <path
                className="cls-1"
                style={{
                  fill: 'none',
                  stroke: '#333',
                  strokeMiterlimit: 10,
                  strokeWidth: 2,
                }}
                d="M3.74,43.81S14.71,33.58,6.42,19s23-28.13,33.63-9.42c7.47,13.16-12.67,6.74-13.24,12.51"
              />
              <circle
                className="cls-1"
                style={{
                  fill: 'none',
                  stroke: '#333',
                  strokeMiterlimit: 10,
                  strokeWidth: 2,
                }}
                cx="26.58"
                cy="23.82"
                r="1.91"
              />
              <circle
                className="cls-1"
                style={{
                  fill: 'none',
                  stroke: '#333',
                  strokeMiterlimit: 10,
                  strokeWidth: 2,
                }}
                cx="2.41"
                cy="45.12"
                r="1.91"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ToPointIcon = (props) => (
  <Icon {...props} component={() => <ToPointSvg {...props} />} />
);

export const ToPointSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 41.16 49.19" width={width} height={height}>
      <g>
        <g>
          <g>
            <g>
              <path
                className="cls-1"
                style={{
                  fill: 'none',
                  stroke: '#333',
                  strokeMiterlimit: 10,
                  strokeWidth: 2,
                }}
                d="M34.75,46.71c-13.65,3.41-24.38,2.4-27.32-3a7.68,7.68,0,0,1-.75-4.62c1.38-12.53,25.75-16.5,26.75-24,.09-1.83-.79-3.88-4.25-4.63C22.56,9.62,13.6,13.56,5.46,25"
              />
              <circle
                className="cls-2"
                style={{ fill: '#333' }}
                cx="35.79"
                cy="46.58"
                r="1.61"
              />
              <circle
                className="cls-2"
                style={{ fill: '#333' }}
                cx="5.27"
                cy="25.11"
                r="1.61"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M41.16,24.16a2.32,2.32,0,0,0-2.3-2.31l-6,0a2.31,2.31,0,0,0-2.31,2.3l0,6a2.24,2.24,0,0,0,.06.52l.08.28.06.15,5.14,12.76,5.25-13.19a2.63,2.63,0,0,0,0-.49ZM40.27,30a1.67,1.67,0,0,1-1.67,1.67L33,31.6a1.67,1.67,0,0,1-1.67-1.67l0-5.56a1.67,1.67,0,0,1,1.67-1.67l5.56,0a1.67,1.67,0,0,1,1.67,1.68Z"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M10.66,2.33A2.31,2.31,0,0,0,8.36,0l-6,0A2.31,2.31,0,0,0,0,2.3l0,6a2.31,2.31,0,0,0,.06.52l.08.27.06.16L5.34,22,10.59,8.85a2.63,2.63,0,0,0,.05-.49ZM9.77,8.12A1.67,1.67,0,0,1,8.1,9.79l-5.56,0A1.67,1.67,0,0,1,.87,8.09l0-5.55A1.67,1.67,0,0,1,2.56.87l5.56,0A1.67,1.67,0,0,1,9.79,2.56Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RoundTripIcon = (props) => (
  <Icon {...props} component={() => <RoundTripSvg {...props} />} />
);

export const RoundTripSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 41.73 49.06" width={width} height={height}>
      <g>
        <g>
          <g>
            <g>
              <path
                className="cls-1"
                style={{
                  fill: 'none',
                  stroke: '#333',
                  strokeMiterlimit: 10,
                  strokeWidth: 2,
                }}
                d="M5,31.16c-2.3,11.11,6.89,22.78,24.62,14.72C49.88,36.8,40.55-2.62,24.94.7,16.79,2.45,17.42,12.07,19,19,20.56,25.66,15.3,31.94,8.86,31c-1.45-.22-2.42-.46-2.42-.46a1.37,1.37,0,0,0-1,.16A1.35,1.35,0,0,0,5,31.16Z"
              />
              <ellipse
                className="cls-2"
                style={{ fill: '#333' }}
                cx="5.52"
                cy="30.22"
                rx="1.71"
                ry="1.79"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M10.66,7.51A2.31,2.31,0,0,0,8.36,5.2l-6,0A2.31,2.31,0,0,0,0,7.48l0,6A2.31,2.31,0,0,0,.06,14l.08.27.06.16L5.34,27.22,10.59,14a2.63,2.63,0,0,0,.05-.49ZM9.77,13.3A1.67,1.67,0,0,1,8.1,15L2.54,15A1.67,1.67,0,0,1,.87,13.27l0-5.55A1.67,1.67,0,0,1,2.56,6.05l5.56,0A1.67,1.67,0,0,1,9.79,7.74Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RidePlanIcon = (props) => (
  <Icon {...props} component={() => <RidePlanSvg {...props} />} />
);

export const RidePlanSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg
      viewBox="0 0 41.41 48.04"
      width={width}
      height={height}
      preserveAspectRatio="none"
    >
      <g>
        <g>
          <g>
            <g>
              <path
                className="cls-1"
                style={{
                  fill: 'none',
                  stroke: '#333',
                  strokeMiterlimit: 10,
                  strokeWidth: 2,
                }}
                d="M35,46.34C15,43.5,9.46,40.76,9.4,38.51,9.32,35.06,22,32.87,21.75,29.62c-.19-2.5-8-4-16-5"
              />
              <circle
                className="cls-2"
                style={{ fill: '#333' }}
                cx="35.9"
                cy="46.43"
                r="1.61"
              />
              <circle
                className="cls-2"
                style={{ fill: '#333' }}
                cx="5.49"
                cy="24.7"
                r="1.61"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M17.85,18.8a.67.67,0,0,0-.67-.67H15.43a.66.66,0,0,0-.67.66v1.76a.77.77,0,0,0,0,.15l0,.08,0,0,1.49,3.72,1.53-3.84a.68.68,0,0,0,0-.14Zm-.26,1.69a.48.48,0,0,1-.48.48H15.49a.49.49,0,0,1-.49-.49V18.86a.48.48,0,0,1,.49-.48h1.61a.49.49,0,0,1,.49.49Z"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M28.1,36.93a.67.67,0,0,0-.67-.67H25.68a.67.67,0,0,0-.67.67v1.75a.61.61,0,0,0,0,.15l0,.09s0,0,0,0l1.49,3.71,1.53-3.84a.59.59,0,0,0,0-.14Zm-.26,1.68a.49.49,0,0,1-.48.49H25.74a.49.49,0,0,1-.49-.48V37a.49.49,0,0,1,.49-.49h1.61a.49.49,0,0,1,.49.49Z"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M10.66,2.33A2.31,2.31,0,0,0,8.36,0l-6,0A2.31,2.31,0,0,0,0,2.3l0,6a2.31,2.31,0,0,0,.06.52l.08.27.06.16L5.34,22,10.59,8.85a2.63,2.63,0,0,0,.05-.49ZM9.77,8.12A1.67,1.67,0,0,1,8.1,9.79l-5.56,0A1.67,1.67,0,0,1,.87,8.09l0-5.55A1.67,1.67,0,0,1,2.56.87l5.56,0A1.67,1.67,0,0,1,9.79,2.56Z"
              />
              <path
                className="cls-2"
                style={{ fill: '#333' }}
                d="M41.41,24.46a2.32,2.32,0,0,0-2.3-2.32h-6a2.29,2.29,0,0,0-2.31,2.29l0,6a2.24,2.24,0,0,0,.06.52l.08.28.06.15,5.14,12.76L41.34,31a2.63,2.63,0,0,0,0-.49Zm-.89,5.78a1.67,1.67,0,0,1-1.67,1.67l-5.56,0a1.67,1.67,0,0,1-1.67-1.67l0-5.56A1.66,1.66,0,0,1,33.31,23h5.56a1.68,1.68,0,0,1,1.67,1.68Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SliderRouteIcon = (props) => (
  <Icon {...props} component={() => <SliderRouterSvg {...props} />} />
);

export const SliderRouterSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 498.08 91.91" width={width} height={height}>
      <g>
        <g>
          <path
            className="cls-1"
            style={{ fill: '#42295e', transform: 'scaleY(0.8)' }}
            d="M6.33,67.5C18.6,63.31,31,59.21,43.9,57.29a79.1,79.1,0,0,1,37.15,3.25c11.55,3.85,22.6,9.3,34.65,11.5,8.91,1.62,18.42,1.9,27.11-1a38.75,38.75,0,0,0,15.27-9.8,62.33,62.33,0,0,0,8.44-11.09A33.86,33.86,0,0,1,171.11,44c.73-.76,1.51-1.48,2.31-2.17A26.11,26.11,0,0,1,177.17,39a40.15,40.15,0,0,1,12.14-5.56c8.4-2.18,17.58-1,25.53,2.33A37.71,37.71,0,0,1,224,41.4a65.33,65.33,0,0,1,7.6,8C237.06,56,242.1,63,248.37,68.91a96,96,0,0,0,29.27,19c7.3,3,15.13,4.68,23,3.81,20.08-2.23,37.13-17.11,46.71-34.17,2.75-4.88,5.35-9.88,7.68-15,1.75-3.82,3.17-7.81,5.16-11.5a43.44,43.44,0,0,1,18-17.52c9.47-4.65,21-4.26,31-1.71a39.08,39.08,0,0,1,12.49,5.43A58.08,58.08,0,0,1,431.15,26a138,138,0,0,0,18.5,17.27,131,131,0,0,0,24.64,14.28q8.56,3.87,17.46,6.92c2.55.89,5.47-1,6.15-3.49a5.09,5.09,0,0,0-3.49-6.15c-17.89-6.19-35.3-14.88-48.49-27.79C439,20.33,433.23,12.38,424.83,7.38,416.27,2.28,405.58.08,395.69,0c-12-.09-23.53,3.7-32.45,11.86a68.43,68.43,0,0,0-9.36,10.47,50.58,50.58,0,0,0-5.19,10C344.65,41.84,340,51.57,334,60c-5.07,7.19-12.3,12.9-20,17.1a39.09,39.09,0,0,1-13.37,4.54,34.9,34.9,0,0,1-5.6.24c-.64,0-1.28-.06-1.91-.11l-.83-.09c-.58-.07-.58-.06,0,0l-.93-.15c-10.39-1.91-20-7.25-28.46-13.43-7.46-5.45-13.59-12.36-19.29-19.56-4.9-6.18-9.69-12.31-16.08-17-15.6-11.53-37.92-12.22-54.26-2a45.16,45.16,0,0,0-13.65,12.82c-4.27,6.25-7.95,12.58-14.59,16.72a23.46,23.46,0,0,1-2.19,1.22c-.27.13-1.95.84-.59.29-.71.29-1.42.55-2.14.8a33.17,33.17,0,0,1-9.91,1.8C118.81,63.72,108,60,97.43,56c-12-4.59-23.8-8.94-36.77-9.56-13.17-.63-26.38,2-39,5.64-6.06,1.75-12,3.75-18,5.79A5.12,5.12,0,0,0,.18,64,5,5,0,0,0,6.33,67.5Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const SliderMarkerIcon = (props) => (
  <Icon {...props} component={() => <SliderMarkerSvg {...props} />} />
);

export const SliderMarkerSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 36.31 69.38" width={width} height={height}>
      <g>
        <g>
          <path
            className="cls-1"
            style={{
              fill: '#a2c64b',
              stroke: '#6a6b68',
              strokeMiterlimit: 10,
              strokeWidth: 2,
            }}
            d="M1,1,35.31,1V48.31q-8.55,9.77-17.09,19.55L1,48.31Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const RecalculationMAndRIcon = (props) => (
  <Icon {...props} component={() => <RecalculationMAndRSvg {...props} />} />
);

export const RecalculationMAndRSvg = ({ width = 22, height = 22, fill }) => {
  return (
    <svg viewBox="0 0 72.97 63.45" width={width} height={height}>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            style={{ fill }}
            d="M7.43,63.35c10.51-4.25,21.09-8.53,32-11.77a58.09,58.09,0,0,1,7.47-1.82l.39-.06.56-.06c.34,0,.68,0,1,0,1.55,0,3,.29,4.56-.27a4.21,4.21,0,0,0,2.53-2.46c.49-1.25.47-2.63,1-3.87.88-2,3.53-3.07,5.18-4.32,1.44-1.08,3.69-2.58,4-4.52s-1.47-2.75-3-3.23c-1.84-.6-4-.83-5.6-2.08a2.28,2.28,0,0,1,.58-4c2.74-1.13,9.49-1.59,7.1-6.25-2.07-4-7.15-6.06-8.62-10.47-1-2.87,2-4.85,4.47-5.46,3.44-.85,7.2,1.92,9.67,4.06,1.21,1,3-.71,1.76-1.77-2.26-2-5.07-4-8-4.69a9.51,9.51,0,0,0-8.17,2,5.94,5.94,0,0,0-2.19,6.27A14,14,0,0,0,57.82,14c1.49,1.58,3.18,3,4.55,4.68a4.28,4.28,0,0,1,.89,1.49c0,.16.06.14-.13.34a3,3,0,0,1-1.06.54c-2,.72-4.44.85-6.22,2.18A4.83,4.83,0,0,0,54.55,29c1,2,3.1,2.89,5.08,3.51,1,.3,1.95.52,2.91.83a4.6,4.6,0,0,1,1,.38c.29.18.19.27.24.05s-.31.44-.44.6a10.11,10.11,0,0,1-1.19,1.17,32.43,32.43,0,0,1-2.83,2.15c-2.1,1.45-4,2.57-4.9,5.12-.38,1.1-.27,2.81-1.07,3.7s-2.21.75-3.23.68a13,13,0,0,0-2.16,0,35.69,35.69,0,0,0-6.57,1.29c-9.91,2.66-19.53,6.51-29,10.29-1.85.73-3.69,1.47-5.54,2.22-1.47.59-.83,3,.67,2.41Z"
          />
          <path
            className="cls-1"
            style={{ fill }}
            d="M50.8,38.45a7,7,0,0,0-8.95-4.38,7.23,7.23,0,0,0-1.23.56l-1.17-1.17h0a3.88,3.88,0,0,0,.91-.72,3.16,3.16,0,0,0,.55-.91,3.54,3.54,0,0,0,.1-3,4.85,4.85,0,0,0-.54-1,8.21,8.21,0,0,0-3.61-2.46,17.3,17.3,0,0,0-4.51-1.25c-.07,0-7.22-1-7.66,1.23a1.64,1.64,0,0,0,.73,1.47l.2.16,3.54-.11,0,1.05a12.77,12.77,0,0,1-1.48.48c-.4.1-.68.15-.93.19a3.7,3.7,0,0,0-1.2.38,5.46,5.46,0,0,0-1.83,1.84l0,.06a6.15,6.15,0,0,0-1.15,2.27,3,3,0,0,0-.09.89,1.78,1.78,0,0,1-.05.47A4.33,4.33,0,0,1,21,36.74a5.5,5.5,0,0,1-1.8,1.14,7.52,7.52,0,0,1-2.51.25,17.14,17.14,0,0,1-3.47-.42l-.19,0L0,42.12l.1.58a2.88,2.88,0,0,0,.61,1.35,3.85,3.85,0,0,0,1.41,1,12.89,12.89,0,0,0,1.21.51l.2.07,5.08-1.26,5.86,2.91-1.12.54a7.3,7.3,0,0,0-7.12-1.56,7,7,0,0,0,4.56,13.33c3.91-1.34,5.12-5.59,4.5-8.49L17,50.33A4.27,4.27,0,0,0,17.94,52a4.32,4.32,0,0,0,1.38,1,4.22,4.22,0,0,0,2.24.33h.07l11-3.65.13-.18a17,17,0,0,0,2-3.91,8.89,8.89,0,0,0,.64-2.92,4.51,4.51,0,0,0-.15-1.2,3.52,3.52,0,0,1-.14-.94,6.53,6.53,0,0,1,.53-3,11.06,11.06,0,0,1,.88-1.56l.09-.14L38,37.25a7,7,0,1,0,12.79,1.2ZM9.93,57a4.32,4.32,0,1,1,.63-7.9.54.54,0,0,1,.22.73.53.53,0,0,1-.72.22,3.25,3.25,0,1,0,1.68,2.39.55.55,0,0,1,.46-.61.53.53,0,0,1,.6.45A4.31,4.31,0,0,1,9.93,57ZM46,44.6a3.88,3.88,0,0,1-.56.23,4.3,4.3,0,0,1-5.24-2.14,4.31,4.31,0,0,1-.2-3.43.54.54,0,0,1,.69-.32.55.55,0,0,1,.32.69,3.18,3.18,0,0,0,.15,2.58,3.24,3.24,0,1,0,2-4.58.54.54,0,0,1-.3-1,4.32,4.32,0,0,1,3.16,8Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const RoundArrowIcon = (props) => (
  <Icon {...props} component={() => <RoundArrowSvg {...props} />} />
);

export const RoundArrowSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 135 135" width={width} height={height}>
      <g>
        <g>
          <path
            className="cls-1"
            style={{
              fill: '#fff',
              stroke: 'rgb(107, 108, 105)',
              strokeMiterlimit: 10,
              strokeWidth: 2,
            }}
            d="M120.36,14.46a.6.6,0,0,0-1-.4l-5.88,6a8,8,0,0,0-.56-.6A66.09,66.09,0,1,0,86.83,130.89a7,7,0,0,0-4.06-13.4A52.14,52.14,0,1,1,103.3,29.61c.11.11.24.2.36.3l-5.12,5.17a.61.61,0,0,0,.42,1l21.71.68a.61.61,0,0,0,.62-.63Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const CompassBorderIcon = (props) => (
  <Icon {...props} component={() => <CompassBorderSvg {...props} />} />
);

export const CompassBorderSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 251.34 252.36" width={width} height={height}>
      <g>
        <g>
          <g>
            <g>
              <path
                className="cls-1"
                style={{ fill: '#42285e' }}
                d="M251.34,121.41h-7.61A118.06,118.06,0,0,0,130.65,8.4V0h-9V8c-2.35.18-4.68.49-7.11.83l-3.64.48A118.91,118.91,0,0,0,9,104.77a125.28,125.28,0,0,0-2.08,16.64H0v9H6.88A118.67,118.67,0,0,0,121.6,244.85v7.51h9v-7.57A118.73,118.73,0,0,0,243.77,130.41h7.57Zm-126,110A105.08,105.08,0,1,1,230.39,126.36,105.19,105.19,0,0,1,125.31,231.44Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CompassArrowIcon = (props) => (
  <Icon {...props} component={() => <CompassArrowSvg {...props} />} />
);

export const CompassArrowSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 131.95 122.3" width={width} height={height}>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Compass">
          <g id="RoundTrip_Compass" data-name="RoundTrip Compass">
            <path
              className="cls-1"
              style={{
                fill: '#9fbf4d',
                stroke: '#6b6cc69',
                strokeMiterlimit: 10,
                strokeWidth: 2,
              }}
              d="M129.88,2.39,92,1a1,1,0,0,0-.75,1.75L104.2,17,1.9,109.86a2.74,2.74,0,0,0-.19,3.87l6.06,6.67a2.73,2.73,0,0,0,3.86.19l102.3-92.87L126.86,42a1,1,0,0,0,1.81-.58L131,3.56A1.13,1.13,0,0,0,129.88,2.39Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CompassArrowDefaultIcon = (props) => (
  <Icon {...props} component={() => <CompassArrowDefaultSvg {...props} />} />
);

export const CompassArrowDefaultSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 99.23 102.16" width={width} height={height}>
      <g>
        <g>
          <path
            className="cls-1"
            style={{
              fill: '#a2c64b',
              stroke: '#6b6c69',
              strokeMiterlimit: 10,
              strokeWidth: 2,
            }}
            d="M97.31,84.24,31.56,16,43.31,3.87A1.72,1.72,0,0,0,43.67,2a1.63,1.63,0,0,0-1.51-1H1V43.44A1.69,1.69,0,0,0,2,45a1.59,1.59,0,0,0,1.77-.37L16,32l65.69,68.2a3.11,3.11,0,0,0,4.49,0L97.29,88.87A3.35,3.35,0,0,0,97.31,84.24Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const CompassArrowRedIcon = (props) => (
  <Icon {...props} component={() => <CompassArrowRedSvg {...props} />} />
);

export const CompassArrowRedSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 70.44 72.64" width={width} height={height}>
      <g>
        <g>
          <path
            className="cls-1"
            style={{ stroke: '#6b6c69', strokeMiterlimit: 10, strokeWidth: 2 }}
            d="M69.24,13.85,57.2,1.43h0l-12,12.42a.71.71,0,0,0-.15.76.67.67,0,0,0,.62.43h6.9c0,21.57-17,39.13-37.95,39.13V47.09a.69.69,0,0,0-.41-.64.66.66,0,0,0-.74.15L1.39,59h0l12,12.42a.66.66,0,0,0,.74.15.69.69,0,0,0,.41-.64v-7.2C40.63,63.75,61.82,41.9,61.82,15h6.95a.67.67,0,0,0,.62-.43A.71.71,0,0,0,69.24,13.85Z"
          />
        </g>
      </g>
    </svg>
  );
};

export const MoveMapFreeHandIcon = (props) => (
  <Icon {...props} component={() => <MoveMapFreeHandSvg {...props} />} />
);

export const MoveMapFreeHandSvg = ({ width = 22, height = 22 }) => {
  return (
    <svg viewBox="0 0 20.34 20.4" width={width} height={height}>
      <g>
        <g>
          <ellipse
            className="cls-1"
            style={{
              fill: '#e5e5e5',
              stroke: '#222221',
              strokeMiterlimit: 10,
              strokeWidth: 0.4,
            }}
            cx="10.2"
            cy="10.23"
            rx="3.64"
            ry="3.54"
            transform="translate(-4.24 10.21) rotate(-45)"
          />
          <path
            className="cls-2"
            style={{
              fill: '#e5e5e5',
              stroke: '#363636',
              strokeMiterlimit: 10,
              strokeWidth: 0.4,
            }}
            d="M9.78,7.91V4.14l-1.61,0a.33.33,0,0,1-.29-.52l2-3.29a.35.35,0,0,1,.59,0l2,3.18a.36.36,0,0,1-.3.54l-1.61,0V7.9a.41.41,0,0,1-.41.41A.4.4,0,0,1,9.78,7.91Z"
          />
          <path
            className="cls-2"
            style={{
              fill: '#e5e5e5',
              stroke: '#363636',
              strokeMiterlimit: 10,
              strokeWidth: 0.4,
            }}
            d="M12.43,10.6H16.2l-.05,1.62a.33.33,0,0,0,.52.29l3.3-2a.35.35,0,0,0,0-.59l-3.17-2a.36.36,0,0,0-.54.29l-.05,1.62H12.44a.41.41,0,0,0-.41.4A.4.4,0,0,0,12.43,10.6Z"
          />
          <path
            className="cls-2"
            style={{
              fill: '#e5e5e5',
              stroke: '#363636',
              strokeMiterlimit: 10,
              strokeWidth: 0.4,
            }}
            d="M7.91,9.82H4.14L4.19,8.2a.34.34,0,0,0-.52-.29l-3.3,2a.35.35,0,0,0,0,.59l3.18,2a.35.35,0,0,0,.54-.29l0-1.62H7.9a.42.42,0,0,0,.41-.4A.4.4,0,0,0,7.91,9.82Z"
          />
          <path
            className="cls-2"
            style={{
              fill: '#e5e5e5',
              stroke: '#363636',
              strokeMiterlimit: 10,
              strokeWidth: 0.4,
            }}
            d="M10.62,12.49v3.77l1.61,0a.33.33,0,0,1,.29.52l-2,3.29a.35.35,0,0,1-.59,0l-2-3.19a.36.36,0,0,1,.29-.54l1.62,0V12.5a.41.41,0,0,1,.4-.41A.4.4,0,0,1,10.62,12.49Z"
          />
        </g>
      </g>
    </svg>
  );
};
